import { PageTitle } from "@/components/shared/title/page-title";
import { LadleHeatMetricsPage } from "./LadleHeatMetricsPage";
import { LadleHMProvider } from "./context/LadleHeatMetricContext";

const LadleHeatMetrics = () => {
	return (
		<>
			<PageTitle title="Ladle Heat Metrics" />
			<LadleHMProvider>
				<LadleHeatMetricsPage />
			</LadleHMProvider>
		</>
	);
};

export default LadleHeatMetrics;
